<script>
export default {
  data() {
    return {
      isPasswordVisible: false,
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
};
</script>
<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="row">
          <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
            <h5>Device Management</h5>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-xl-12 col-lg-12">
            <!-- Coupons List -->
            <div class="custom-datatable-filter table-responsive">
              <table class="table datatable">
                <thead class="thead-light">
                  <tr>
                    <th>Device Name</th>
                    <th>Date</th>
                    <th>IP Address</th>
                    <th>Location</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><p>Chrome - Windows</p></td>

                    <td>
                      <span class="fs-14">22 Sep 2022, 11:40:30</span>
                    </td>
                    <td><span class="fs-14">232.222.12.72</span></td>
                    <td><span class="fs-14">Chennai / India</span></td>
                    <td>
                      <span
                        class="badge badge-soft-danger d-inline-flex align-items-center"
                        >Delete</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td><p>Safari Macos</p></td>

                    <td>
                      <span class="fs-14">21 Sep 2022, 13:10:50</span>
                    </td>
                    <td><span class="fs-14">224.111.12.75</span></td>
                    <td><span class="fs-14">Newyork / USA</span></td>
                    <td>
                      <span
                        class="badge badge-soft-danger d-inline-flex align-items-center"
                        >Delete</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td><p>Firefox Windows</p></td>

                    <td>
                      <span class="fs-14">20 Sep 2022, 14:16:10</span>
                    </td>
                    <td><span class="fs-14">111.222.13.28</span></td>
                    <td><span class="fs-14">Chennai / India</span></td>
                    <td>
                      <span
                        class="badge badge-soft-danger d-inline-flex align-items-center"
                        >Delete</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td><p>Safari Macos</p></td>

                    <td>
                      <span class="fs-14">19 Sep 2022, 10:20:20</span>
                    </td>
                    <td><span class="fs-14">333.555.10.54</span></td>
                    <td><span class="fs-14">Chennai / India</span></td>
                    <td>
                      <span
                        class="badge badge-soft-danger d-inline-flex align-items-center"
                        >Delete</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- /Coupons List -->
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
    <!-- Delete Account -->
    <div class="modal fade custom-modal" id="del-account">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div
            class="modal-header d-flex align-items-center justify-content-between border-bottom"
          >
            <h5 class="modal-title">Delete Account</h5>
            <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
              ><i class="ti ti-circle-x-filled fs-20"></i
            ></a>
          </div>
          <form action="#">
            <div class="modal-body">
              <p class="mb-3">
                Are you sure you want to delete This Account? To delete your account, Type
                your password.
              </p>
              <div class="mb-0">
                <label class="form-label">Password</label>
                <div class="pass-group">
                  <input
                    :type="isPasswordVisible ? 'text' : 'password'"
                    class="form-control pass-input"
                    placeholder="*************"
                  />
                  <span
                    @click="togglePasswordVisibility"
                    :class="
                      isPasswordVisible
                        ? 'toggle-password feather-eye'
                        : 'toggle-password feather-eye-off'
                    "
                  ></span>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <a
                href="javascript:void(0);"
                class="btn btn-light me-2"
                data-bs-dismiss="modal"
                >Cancel</a
              >
              <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">Delete Account</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- /Delete Account -->
  </div>
</template>
